import { getChipsFiltersFields, getModalFiltersFields } from '@/pages/entity/models/entity-controls'

export default {
  SET_ACTIVE_ENTITY(state, payload) {
    state.activeEntity = payload
  },
  SET_ENTITY_PROVIDED_SERVICE_LIST(state, payload) {
    state.entityProvidedServiceList = payload
  },
  SET_ENTITY_PAYMENT_SERVICE_LIST(state, payload) {
    state.entityPaymentServiceList = payload
  },
  SET_ENTITY_PAYMENT_METHOD_LIST(state, payload) {
    state.entityPaymentMethodList = payload
  },
  SET_ENTITY_BANKS_LIST(state, payload) {
    state.entityBanksList = payload
  },
  SET_ENTITY_TAGS_LIST(state, payload) {
    state.entityTagsList = payload
  },
  SET_ENTITY_TYPES_LIST(state, payload) {
    state.entityTypesList = payload
  },
  SET_ENTITY_REGULATORS_LIST(state, payload) {
    state.entityRegulatorsList = payload
  },
  SET_ACTIVE_SEARCH_FIELD(state, payload) {
    state.activeSearchField = payload
  },
  SET_POPULAR_LIST_FILTER(state, payload) {
    state.isPopularListFilter = payload
  },
  SET_CHIPS_FILTERS(state, payload) {
    state.chipsFilters = payload
  },
  SET_MODAL_FILTERS(state, payload) {
    state.modalFilters = payload
  },
  SET_INITIAL_CHIPS_FILTERS(state) {
    state.chipsFilters = getChipsFiltersFields()
  },
  SET_INITIAL_MODAL_FILTERS(state) {
    state.modalFilters = getModalFiltersFields()
  },
}